/**
 * What every `/orca/v3` route shares: a signed-in session (never `requireAdmin` — a
 * member reads their own loops and runs; the rpcs scope them to the member's customer)
 * and the frame's stylesheets.
 *
 * @since 1.0.0
 */
import { requireAuth } from "./server-auth.ts";
import { v3StylesheetLinks } from "./v3-head.ts";

/**
 * @since 1.0.0
 */
// oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
export const v3BeforeLoad = async () => {
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
  const auth = await requireAuth();
  return { auth };
};

/**
 * @since 1.0.0
 */
export const v3Head = () => ({ links: v3StylesheetLinks });
